<script setup lang="ts">
  import { cva } from 'class-variance-authority'
  type TType = 'white' | 'warning' | 'info'

  const props = withDefaults(
    defineProps<{
      text: string
      tooltipStyle?: TType
      hoverable?: boolean
      disabled?: boolean
    }>(),
    {
      tooltipStyle: 'white',
      hoverable: false,
      disabled: false
    }
  )

  const tooltipContent = computed(() =>
    cva('max-w-[375px] z-30 rounded text-center px-4 py-3 text-body-2 leading-none will-change-[transform,opacity]', {
      variants: {
        style: {
          white: 'bg-white shadow-sm',
          info: 'bg-light-info',
          warning: 'bg-light-warning'
        }
      }
    })({
      style: props.tooltipStyle ?? 'white'
    })
  )
  const tooltipArrow = computed(() =>
    cva('', {
      variants: {
        style: {
          white: 'fill-white shadow-sm',
          info: 'fill-light-info',
          warning: 'fill-light-warning'
        }
      }
    })({
      style: props.tooltipStyle ?? 'white'
    })
  )
</script>
<template>
  <TooltipProvider
    :delay-duration="0"
    :disable-hoverable-content="!hoverable"
    disable-closing-trigger
    :disabled="disabled"
  >
    <TooltipRoot>
      <TooltipTrigger class="size-full">
        <slot />
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          :class="tooltipContent"
          :side-offset="5"
        >
          <div
            class="[&_a]:text-body-2"
            v-html="text"
          />
          <TooltipArrow
            :class="tooltipArrow"
            :width="8"
          />
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>
